// 顧客宛文書承認(完了)
import React from 'react';
import { render } from 'react-dom';
import { Row, Col } from 'react-bootstrap';

const CustomerDocumentApprovalComplete = () => {
  // 顧客宛文書一覧へボタン押下時の処理
  const handleClickReturn = () => {
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/customer_document/list`);
  };

  return (
    <div className="maintenance">
      <div className="title">顧客宛文書</div>
      <div className="maintenance_container">
        <div className="contents">
          <div className="page-title">顧客宛文書承認(完了)</div>
          <br />
          <p className="text-center">
            顧客宛文書の承認が完了しました。
          </p>
        </div>
        <Row className="footer-button-block mt-3">
          <Col className="footer-btn">
            <a className={`btn btn-mini btn-success`} onClick={handleClickReturn}>顧客宛文書一覧へ</a>
          </Col>
        </Row>
      </div>
    </div>
  );
};

if (document.getElementById('customer-document-approval-complete')) {
  render(<CustomerDocumentApprovalComplete />, document.getElementById('customer-document-approval-complete'));
}
